<div class="find-a-background-web">
    <div class="find-a-title-web">{{title}}</div>
    <div class="find-a-description-web">{{searchByText}}</div>
    <form [formGroup]="providerSearchForm" (ngSubmit)="onSubmit()">
        <div class="find-a-search-bar-web">
            <div class="input-icon-container-web name-specialty" style="position: relative; display: flex; align-items: center; background-color: #EAEAEB; border-radius: 4px;">
                <span class="search-icon-web" style="position: absolute; left: 12px; color: white; z-index: 2;">
                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.16668 2.06778C5.12911 2.06778 2.66668 4.57195 2.66668 7.661C2.66668 10.75 5.12911 13.2542 8.16668 13.2542C11.2042 13.2542 13.6667 10.75 13.6667 7.661C13.6667 4.57195 11.2042 2.06778 8.16668 2.06778ZM0.833344 7.661C0.833344 3.54226 4.11659 0.203369 8.16668 0.203369C12.2168 0.203369 15.5 3.54226 15.5 7.661C15.5 9.38437 14.9252 10.9712 13.9599 12.2341L18.8982 17.2561C19.2562 17.6201 19.2562 18.2104 18.8982 18.5744C18.5402 18.9384 17.9598 18.9384 17.6018 18.5744L12.6635 13.5524C11.4217 14.5341 9.86133 15.1186 8.16668 15.1186C4.11659 15.1186 0.833344 11.7797 0.833344 7.661Z" fill="#0D0D0D"/>
                    </svg>
                </span>
                <input 
                    mat-input 
                    type="text" 
                    formControlName="nameOrSpecialty" 
                    [placeholder]="namePlaceholderText" 
                    [matAutocomplete]="auto"
                    class="name-specialty-search-input-web"
                    required>
                <mat-autocomplete #auto="matAutocomplete" class="autocomplete-panel-below">
                    <mat-option *ngFor="let option of filteredNameOrSpecialties$ | async" [value]="option">
                        {{option}}
                    </mat-option>
                </mat-autocomplete>
            </div>
        </div>
        <div class="find-a-search-bar-web city-zip">
            <div class="input-icon-container-web" style="position: relative; display: flex; align-items: center; background-color: #EAEAEB; border-radius: 4px;">
                <span class="search-icon-web" style="position: absolute; left: 12px; color: white; z-index: 2;">
                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.37584 2.85915C4.65549 1.61971 6.19686 1 8 1C9.80314 1 11.3372 1.61267 12.6023 2.83803C13.8675 4.06339 14.5 5.54929 14.5 7.29577C14.5 8.16902 14.2746 9.16901 13.8238 10.2958C13.373 11.4225 12.8277 12.4789 12.1879 13.4648C11.5481 14.4507 10.9156 15.3732 10.2903 16.2324C9.66499 17.0916 9.13423 17.7746 8.69799 18.2817L8 19C7.8255 18.8028 7.59284 18.5423 7.30201 18.2183C7.01118 17.8944 6.4877 17.2465 5.73154 16.2746C4.97539 15.3028 4.31376 14.3592 3.74664 13.4437C3.17953 12.5282 2.66331 11.493 2.19799 10.338C1.73266 9.18309 1.5 8.16902 1.5 7.29577C1.5 5.54929 2.12527 4.07043 3.37584 2.85915Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 7.5C9 8.05228 8.55228 8.5 8 8.5C7.44772 8.5 7 8.05228 7 7.5C7 6.94772 7.44772 6.5 8 6.5C8.55228 6.5 9 6.94772 9 7.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <input mat-input 
                    type="text" 
                    formControlName="cityOrZip" 
                    [placeholder]="cityZipPlaceholderText" 
                    [matAutocomplete]="cityAuto"
                    class="city-zip-search-input-web" 
                    required>
                <mat-autocomplete #cityAuto="matAutocomplete" class="autocomplete-panel-below">
                    <mat-option *ngFor="let option of filteredCityOptions$ | async" [value]="option">
                        {{option}}
                    </mat-option>
                </mat-autocomplete>
            </div>
        </div>
        <div class="required-label-web">{{locationInformationRequiredText}}</div>
        <br>
        <div class="find-a-search-btn-container-web">
            <button mat-button type="submit" [disabled]="!providerSearchForm.valid || showSpinner==true" class="find-a-search-btn-web">{{searchBtnText}}</button>
        </div>
    </form>
    <div *ngIf="providerQuickSearchOptions != null && providerQuickSearchOptions.length > 0 && showSpinner == false" class="quick-search-text">{{quickSearchTitleText}}</div>
    <div *ngIf="providerQuickSearchOptions != null && providerQuickSearchOptions.length > 0 && showSpinner == false" class="quick-search-btn-container-web">
        <div *ngFor="let option of providerQuickSearchOptions">
            <button class="quick-search-btn-web" [disabled]="!providerSearchForm.get('cityOrZip')?.value"  (click)="onQuickSearch(option)">{{option.name}}</button>
        </div>
    </div>
    <div *ngIf="showSpinner == true" >
        <div class="spinner-container-web">
            <mat-spinner diameter="70"></mat-spinner>
        </div>
    </div>
</div>